/**
 * MSK Finding Chart Reducers
 */
import {
   ALL_FINDINGCHARTS,
   ADD_FINDINGCHART,
   FINDINGCHART_ACTION,
   EDIT_FINDINGCHART,
   FETCH_FINDINGCHART,
   DELETE_FINDINGCHART,
   FETCH_STUDENTFINDINGS,
   CHART_FINDINGREPORT,
   ALL_FINDINGREPORTS,
   DELETE_FINDINGREPORTS,
   UPDATE_FINDINGREPORT
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    findchartlists:[],
    findchartresponse:[],
    studentfindinglists:[],
    findingreportlists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case FINDINGCHART_ACTION:
            return { ...state, loading: true };

        case ALL_FINDINGCHARTS:
            return { ...state, loading: false, findchartlists: action.payload };  
            
        case ADD_FINDINGCHART:
            return { ...state, loading: false }; 

        case FETCH_FINDINGCHART:
            return { ...state, loading: false, findchartresponse:action.payload };     
        
        case EDIT_FINDINGCHART:
            return { ...state, loading: false };  
        
        case DELETE_FINDINGCHART:
            return { ...state, loading: false }; 
            
        case FETCH_STUDENTFINDINGS:
            return { ...state, loading: false, studentfindinglists:action.payload }; 

        case CHART_FINDINGREPORT:
            return { ...state, loading: false }; 
            
        case ALL_FINDINGREPORTS:
            return { ...state, loading: false, findingreportlists:action.payload }; 

        case DELETE_FINDINGREPORTS:
            return { ...state, loading: false };
                
        case UPDATE_FINDINGREPORT:
            return { ...state, loading: false };     

        default: return { ...state };
    }
}